export default {
  components: {
    styleOverrides: {
      root: {
        minWidth: 35
      }
    }
  }
};
